export default __webpack_public_path__ + "static/media/models10.9ba9e6b1.jfif";